import React, {useState} from 'react'
import styled from 'styled-components'
import SideBar from '../components/sidebar/SideBar'
import NavBar from '../components/nav/PagesNavBar'
import { Heading, Subtitle, TopLine, InfoContainer, InfoWrapper, InfoCard, Text, TextWrapper } from '../components/info_section/InfoElems'
import { FaqWrapper } from '../components/faq_section/FaqElems'
import Footer from '../components/footer/Footer'
import Faq from 'react-faq-component'
import {data2} from '../data/Data'
import icon from '../media/city2.svg'

const Container = styled.div`
  background: #fafafa;
  align-items: center;
  justify-content: center;
  display: flex;
  padding-bottom: 50px;
`
const Img = styled.img`
    height: 200px;
    margin-top: 20px;
    margin-bottom: 30px;
`

const AboutPage = () => {
    const [isOpen, setIsOpen] = useState(false);
  
    const toggle = () => {
      setIsOpen(!isOpen)
    };

  return (
    <>
    <SideBar isOpen={isOpen} toggle={toggle}/>
    <NavBar toggle={toggle}/>
    <div style={{"height": "60px", "background":"#fafafa"}}/>
    <InfoContainer id='help' color={"#fafafa"}>
        <Heading>Sobre Nós 🏡</Heading>
        <div style={{"height": "30px"}}/>
        <TextWrapper>
        <Text>A WasteWise Innovations, reunindo conhecimentos em engenharia civil, engenharia do ambiente e outras áreas, 
          nasce com vontade de liderar a mudança num setor que anseia por mais sustentabilidade. O desperdício, resultante da
          construção e demolição de edifícios, constitui um verdadeiro problema, mas também uma oportunidade, comprovada pelos 
          estudos e constante investigação. Por isso, prometemos manter o foco de construir um futuro melhor, tijolo a tijolo.
          <br />⚠ WasteWise é um projeto de empreendedorismo, não constituindo uma empresa real. ⚠
          <br />
          <br />
          Contacte-nos através de:<br />
          wastewiseinnovations@gmail.com
        </Text>
        </TextWrapper>
    </InfoContainer>
    <div style={{"display":"flex", "background":"#fafafa", "align-items":"center", "justify-content":"center"}}>
      <Img src={icon} />
    </div>
    <Footer />
    </> 
  )
}

export default AboutPage